if (!customElements.get("predictive-search")) {
  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input[type="search"]');
      this.suggestions = document.querySelectorAll(".search-suggestion");
      this.predictiveSearchResults = this.querySelector(".predictive-search");
      this.predictiveSearchResources =
        this.predictiveSearchResults.getAttribute("data-resources-types") ||
        "product";
      this.predictiveSearchMaxSize =
        this.predictiveSearchResults.getAttribute("data-max-results") || 4;
      this.emptyState = document.querySelector("#search-empty-state");
      this.predictiveSearchResults.parentElement.appendChild(this.emptyState);
      this.emptyState.style.display = "grid";
      this.queryLength = this.input.value.length;
      this.input.addEventListener(
        "input",
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
      this.animationQueue = null;
      this.input.addEventListener("keyup", () => {
        if (
          this.queryLength != this.input.value.length &&
          this.input.value.length > 0
        ) {
          this.animateDisplay(true);
        } else if (this.input.value.length == 0) {
          this.animationQueue = null;
          this.animateDisplay(false);
        }
        this.queryLength = this.input.value.length;
      });

      // this checks if the input is empty, and ensures the state is correct, incase text was missed in thre above debounced listener. Without it, the state can sometimes not update
      setInterval(() => {
        if (!this.input.value.trim().length) {
          this.close();
          this.emptyState.style.display = "grid";
        }
      }, 300);
    }

    animateDisplay(show) {
      let opacity = 0;

      if (show == true) {
        clearTimeout(this.animationQueue);
        document.querySelector(".search-modal__overlay").style.opacity = 1;
        document.querySelector(".search-modal__overlay").style.display = "flex";
      } else {
        document.querySelector(".search-modal__overlay").style.opacity = 0;
        this.animationQueue = setTimeout(() => {
          document.querySelector(".search-modal__overlay").style.display =
            "none";
        }, 300);
      }
    }

    onChange() {
      const searchTerm = this.input.value.trim();
      // Here, the input html element is empty
      if (!searchTerm.length) {
        this.close();
        this.emptyState.style.display = "grid";
        return;
      }
      // else, FETCH the results
      this.getSearchResults(searchTerm);
    }

    /**
     * getSearchResults
     * @param {String} searchTerm
     * @description https://shopify.dev/api/ajax/reference/predictive-search
     */
    getSearchResults(searchTerm) {
      fetch(
        `${routes.predictive_search_url}?q=${searchTerm}&resources[type]=${this.predictiveSearchResources}&resources[limit]=${this.predictiveSearchMaxSize}&section_id=predictive-search`
      )
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            this.close();
            throw error;
          }

          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser()
            .parseFromString(text, "text/html")
            .querySelector("#shopify-section-predictive-search").innerHTML;
          this.predictiveSearchResults.innerHTML = resultsMarkup;
          this.emptyState.style.display = "none";
          this.open();
          this.animateDisplay(false);
        })
        .catch((error) => {
          this.close();
          throw error;
        });
    }

    open() {
      this.predictiveSearchResults.style.display = "block";
    }

    close() {
      this.predictiveSearchResults.style.display = "none";
    }
  }

  window.PredictiveSearch = PredictiveSearch;

  customElements.define("predictive-search", PredictiveSearch);
}
